import fp from 'lodash/fp';
import React, { useCallback } from 'react';
import { VariableSizeGrid, VariableSizeGridProps, ListOnItemsRenderedProps } from 'react-window';

import { cn } from 'Modules/ui';

import styles from './index.module.scss';


export type GridAdapterProps = VariableSizeGridProps & {
    onItemsRendered?: (data: ListOnItemsRenderedProps) => any;
}

export const GridAdapter = React.forwardRef<VariableSizeGrid, GridAdapterProps>(({
    onItemsRendered = fp.noop,
    className,
    ...props
}, ref) => (
    <VariableSizeGrid
        ref={ref}
        onItemsRendered={useCallback(
            ({ visibleRowStartIndex, visibleRowStopIndex }) => onItemsRendered({
                visibleStartIndex: visibleRowStartIndex,
                visibleStopIndex: visibleRowStopIndex,
            }),
            [onItemsRendered],
        )}
        className={cn(styles.grid, className)}
        {...props}
    />
));
